import { Component, OnInit, NgZone, HostListener } from "@angular/core";

import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder } from "@angular/forms";

import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { MainAppComponent } from "../../../layout/layout.component";
import {
  OverAllTestRatingModel,
  TestRatingModel,
} from "../../../common/viewModels/Analysis/SampleModel";
import {
  AnalysisSectionEnum,
  SampleTypesEnum,
} from "../../../common/enumcontainer.enum";
import { RecommendationModal } from "../../../common/viewModels/GlobalRegistry/UnitsModel";

import { FormatService } from "../../../common/formatService";

@Component({
  selector: "approvesampleresults",
  templateUrl: "./approvesampleresults.component.html",
  styleUrls: ["./approvesampleresults.component.scss"],
})
export class ApproveSampleResults implements OnInit {
  id: number;
  testRatings: TestRatingModel[];
  approvesampleresults: FormGroup;
  isSubmitted: boolean = false;
  sample: any;
  sampleStatus: number;
  screenTitle: string;
  lstRecommendations: RecommendationModal[] = [];
  lstRecommendations1: RecommendationModal[] = [];
  lstRecommendations2: RecommendationModal[] = [];
  lstTransformerDissolvedGasAnalysysRecomm: RecommendationModal[] = [];
  lstTransformerFuranAnalysysRecomm: RecommendationModal[] = [];
  intsampleTypeId: number = 0;
  lstSecTestRatings: OverAllTestRatingModel[];
  ckeState: {
    [key: string]: {
      show: boolean;
      filtered: RecommendationModal[];
    };
  } = {
    Recommendation: {
      show: false,
      filtered: [],
    },

    Recommendation2: {
      show: false,
      filtered: [],
    },
  };

  quillConfig = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ color: [] }, { background: [] }],
    ],
  };

  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
    private _formatService: FormatService,
    private ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.id = this._route.snapshot.params["id"];
    this.BindApprovedResult(this.id);
    this.BingTestGrades();
    this.BindTestRatingBySampleId(this.id);
    setTimeout(() => {
      this.GetSampleResultsBySampleId(this.id);
    }, 800);
    this.GetSampleStatusBySampleId();
    this.approvesampleresults = this._formBuilder.group({
      SampleId: [0],
      Recommendation: [""],
      Recommendation2: [""],
      LubricantRatingId: [""],
      ContaminationRatingId: [""],
      WearMetalsRatingId: [""],
      AdditivesRatingId: [""],
      FerrographyRatingId: [""],
      TransformerDissolvedGasAnalysysRecomm: [""],
      TransformerFuranAnalysysRecomm: [""],
      AnalysisDate: [""],
    });
  }

  GetSampleStatusBySampleId() {
    this._http.get(this._appUrl.GetSampleStatusBySampleId + this.id).subscribe(
      (data) => {
        this.sampleStatus = data.json().Result;
        if (this.sampleStatus == 3) this.screenTitle = "Approve Sample Results";
        else this.screenTitle = "View Sample Results";
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }

  BindApprovedResult(id) {
    this._mApp.ShowLoader();
    this._http
      .get(this._appUrl.ViewSampleReport + id + "&IsFromGeneral=" + true)
      .subscribe(
        (data) => {
          this._mApp.HideLoader();
          this.sample = data.json().Result.SampleDto;
          this.intsampleTypeId = data.json().Result.SampleDto.SampleTypeId;
          if (
            data.json().Result.SampleDto.SampleTypeId ==
            SampleTypesEnum.TransformerOil
          ) {
            this.GetRecommendationsMinInfoListForTransFormerOil();
          } else {
            this.GetRecommendationsMinInfoList();
          }
          document.getElementById("dvHtmlContent").innerHTML =
            data.json().Result.htmlContent;
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        },
      );
  }

  BingTestGrades() {
    this._http.get(this._appUrl.GetListOfTestRatings).subscribe(
      (data) => {
        if (data.json().Result) {
          this.testRatings = data.json().Result;
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }

  BindTestRatingBySampleId(sampleId) {
    this._http.get(this._appUrl.GetTestRatingId + sampleId).subscribe(
      (data) => {
        if (data.json().Result) {
          this.lstSecTestRatings = data.json().Result;
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }

  OnSubmit(IsSaveNext, IsBothSample) {
    this.isSubmitted = true;
    if (this.approvesampleresults.valid) {
      this._mApp.ShowLoader();
      let sampleResults = this.approvesampleresults.value;
      sampleResults.AnalysisDate = this._formatService.formatDate(
        sampleResults.AnalysisDate,
      );
      sampleResults.IsSaveNext = IsSaveNext;
      sampleResults.SampleId = this._route.snapshot.params["id"];
      this._http
        .post(this._appUrl.UpsertSampleResults, sampleResults)
        .subscribe(
          (data) => {
            this._mApp.HideLoader();
            this._toastrService.success(data.json().Result);
            if (!IsSaveNext && IsBothSample)
              this._router.navigate(["/ferrographysampleresults", this.id]);
            else this._router.navigate(["/samplestatus"]);
          },
          (error) => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result);
          },
        );
    }
  }

  GetSampleResultsBySampleId(id) {
    this._http
      .get(this._appUrl.GetSampleResultsDetailsBySampleId + id)
      .subscribe(
        (data) => {
          //this._mApp.HideLoader();
          if (data.json() != null && data.json() != undefined) {
            if (this.intsampleTypeId == SampleTypesEnum.TransformerOil) {
              const recommendationValue = data.json().Result.Recommendation;
              const Recommendation2Value = data.json().Result.Recommendation2;
              const transformerDissolvedGasAnalysysRecomm =
                data.json().Result.TransformerDissolvedGasAnalysysRecomm ||
                "DGA Test shows normal condition of the Transformer.";
              const transformerFuranAnalysysRecomm =
                data.json().Result.TransformerFuranAnalysysRecomm ||
                "Furan Analysis test results shows all the furanic compounds are in the normal range.";
              this.approvesampleresults.setValue({
                SampleId: data.json().Result.SampleId,
                Recommendation: recommendationValue,
                Recommendation2: Recommendation2Value,
                LubricantRatingId: data.json().Result.LubricantRatingId,
                ContaminationRatingId: data.json().Result.ContaminationRatingId,
                WearMetalsRatingId: data.json().Result.WearMetalsRatingId,
                AdditivesRatingId: data.json().Result.AdditivesRatingId,
                FerrographyRatingId: data.json().Result.FerrographyRatingId,
                TransformerDissolvedGasAnalysysRecomm:
                  transformerDissolvedGasAnalysysRecomm,
                TransformerFuranAnalysysRecomm: transformerFuranAnalysysRecomm,
                AnalysisDate: data.json().Result.AnalysisDate,
              });
            } else {
              const result = data.json().Result;
              const oilCondition = this.lstSecTestRatings.find(
                (x) =>
                  x.AnalysisSectionId === AnalysisSectionEnum.oil_condition,
              );
              const contaminationLevel = this.lstSecTestRatings.find(
                (x) =>
                  x.AnalysisSectionId === AnalysisSectionEnum.OIL_CONDITION_CONTAMINATION,
              );
              const wearMetals = this.lstSecTestRatings.find(
                (x) => x.AnalysisSectionId === AnalysisSectionEnum.WEAR_METALS,
              );
              const additives = this.lstSecTestRatings.find(
                (x) => x.AnalysisSectionId === AnalysisSectionEnum.ADDITIVES,
              );
              // const lubricantRatingId = oilCondition != null ? oilCondition.TestRatingId : null;
              // const contaminationRatingId = contaminationLevel != null ? contaminationLevel.TestRatingId : null;
              // const wearMetalsRatingId = wearMetals != null ? wearMetals.TestRatingId : null;
              // const additivesRatingId = additives != null ? additives.TestRatingId : null;
              const lubricantRatingId = result.LubricantRatingId;
              const contaminationRatingId = result.ContaminationRatingId;
              const wearMetalsRatingId =  result.WearMetalsRatingId;
              const additivesRatingId = result.AdditivesRatingId;
              const recommendationValue = result.Recommendation;
              const Recommendation2Value = result.Recommendation2;

              this.approvesampleresults.setValue({
              SampleId: result.SampleId || 0,
              Recommendation: recommendationValue || null,
              Recommendation2: Recommendation2Value || null,
              LubricantRatingId: lubricantRatingId || null,
              ContaminationRatingId: contaminationRatingId || null,
              WearMetalsRatingId: wearMetalsRatingId || null,
              AdditivesRatingId: additivesRatingId || null,
              FerrographyRatingId: result.FerrographyRatingId || null,
              TransformerDissolvedGasAnalysysRecomm: result.TransformerDissolvedGasAnalysysRecomm || null,
              TransformerFuranAnalysysRecomm: result.TransformerFuranAnalysysRecomm || null,
              AnalysisDate: result.AnalysisDate || null,
            });
          }
          }
        },
        (error) => {
          this._mApp.HideLoader();
          // this._toastrService.error(error.json().Result);
        },
      );
  }

  GetRecommendationsMinInfoList() {
    this._http
      .get(this._appUrl.GetRecommendationsMinInfoList + SampleTypesEnum.General)
      .subscribe(
        (data) => {
          if (data.json().Result != null) {
            this.lstRecommendations = data.json().Result;
            this.lstRecommendations1 = data.json().Result;
            this.lstRecommendations2 = data.json().Result;
          }
        },
        (error) => {
          this._toastrService.error(error.json().Result);
        },
      );
  }
  GetRecommendationsMinInfoListForTransFormerOil() {
    this._http
      .get(
        this._appUrl.GetRecommendationsMinInfoList +
          SampleTypesEnum.TransformerOil,
      )
      .subscribe(
        (data) => {
          if (data.json().Result != null) {
            this.lstRecommendations = data.json().Result;
            this.lstRecommendations1 = data.json().Result;
            this.lstRecommendations2 = data.json().Result;
            this.lstTransformerDissolvedGasAnalysysRecomm = data.json().Result;
            this.lstTransformerFuranAnalysysRecomm = data.json().Result;
          }
        },
        (error) => {
          this._toastrService.error(error.json().Result);
        },
      );
  }

  filterRecommendation(val, type) {
    val = val || "";

    if (type == 1) {
      this.lstRecommendations1 = (this.lstRecommendations || []).filter(
        (x) =>
          x.Recommendation &&
          x.Recommendation.toLowerCase().indexOf(val.toLowerCase()) === 0,
      );
    } else if (type == 2) {
      this.lstRecommendations2 = (this.lstRecommendations || []).filter(
        (x) =>
          x.Recommendation &&
          x.Recommendation.toLowerCase().indexOf(val.toLowerCase()) === 0,
      );
    } else if (type == 3) {
      this.lstTransformerDissolvedGasAnalysysRecomm = (
        this.lstRecommendations || []
      ).filter(
        (x) =>
          x.Recommendation &&
          x.Recommendation.toLowerCase().indexOf(val.toLowerCase()) === 0,
      );
    } else if (type == 4) {
      this.lstTransformerFuranAnalysysRecomm = (
        this.lstRecommendations || []
      ).filter(
        (x) =>
          x.Recommendation &&
          x.Recommendation.toLowerCase().indexOf(val.toLowerCase()) === 0,
      );
    }
  }

  displayFn(rec) {
    return rec;
  }

  onEditorCreated(quill: any, controlName: string) {
    quill.root.addEventListener("focus", () => {
      this.ngZone.run(() => {
        this.filterQuillDropdown(controlName);
      });
    });

    quill.root.addEventListener("click", () => {
      this.ngZone.run(() => {
        this.filterQuillDropdown(controlName);
      });
    });
  }

  onQuillChanged(event: any, controlName: string) {
    this.ngZone.run(() => {
      this.filterQuillDropdown(controlName);
    });
  }

  filterQuillDropdown(controlName: string) {
    Object.keys(this.ckeState).forEach((key) => {
      if (key !== controlName) {
        this.ckeState[key].show = false;
      }
    });
    const state = this.ckeState[controlName];
    const control = this.approvesampleresults.get(controlName);
    const value = control ? control.value : "";
    const text = this.stripHtml(value).trim();
    if (this.lstRecommendations && this.lstRecommendations.length > 0) {
      if (!text) {
        state.filtered = this.lstRecommendations.slice();
      } else {
        state.filtered = this.lstRecommendations.filter(
          (x) =>
            x.Recommendation &&
            x.Recommendation.toLowerCase().indexOf(text.toLowerCase()) !== -1,
        );
      }

      state.show = state.filtered.length > 0;
    } else {
      state.filtered = [];

      state.show = false;
    }
  }

  selectCkeRecommendation(
    item: RecommendationModal,
    controlName: string,
  ): void {
    this.approvesampleresults.patchValue({
      [controlName]: item.Recommendation,
    });
    this.ckeState[controlName].show = false;
    this.ckeState[controlName].filtered = [];
  }

  private stripHtml(html: string): string {
    if (!html) {
      return "";
    }

    return html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: any): void {
    this.ngZone.run(() => {
      const target = event.target;

      const clickedInsideEditor =
        target.closest(".ql-editor") ||
        target.closest(".ql-toolbar") ||
        target.closest(".cke-autocomplete-panel");

      if (!clickedInsideEditor) {
        Object.keys(this.ckeState).forEach((key) => {
          this.ckeState[key].show = false;
        });
      }
    });
  }
}
